import { Job } from 'entities/Job'

import { getObj, getObj2 } from './fetch'

interface Params {
  fromDate: Date
  page?: number
  perPage?: number
}
export async function getJobs(params: Params) {
  const results = await getObj<Job[] | null>('jobs', { params })
  if (results) {
    // can be null
    // improveme: can Axios can do this too?
    results.forEach((j) => Object.setPrototypeOf(j, Job.prototype))
  }
  return results
}

export async function getServerTime() {
  const { time } = await getObj2<{ time: string }>('time')
  return new Date(time)
}
